
















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { MASTER_ROLE } from '@/class/const'
import { RoleId } from '@/enum'
import { RoleSettings } from '@/class/room'
import Card from '@/components/Common/Card/Card.vue'
import RoleView from '@/components/Common/RoleView.vue'
import SimpleModal from '@/components/Utils/modal/SimpleModal.vue'
import HeadlineDot from '@/components/Utils/headline/HeadlineDot.vue'

export interface InTownRoleGuid {
  playersCount: number;
  mustUseRoles: RoleId[];
  randomUseRoles: RoleId[];
  roleSettings: RoleSettings;
}

@Component({
  components: {
    Card,
    RoleView,
    SimpleModal,
    HeadlineDot
  }
})
export default class InTownRoleGuideViewer extends Vue {
  @Prop() data!: InTownRoleGuid;
  show = false;
  selectedRoleId: RoleId | '' = '';

  get mustUseRoles () {
    return this.sumRole(this.data.mustUseRoles)
  }

  get randomUseRoles () {
    return this.sumRole(this.data.randomUseRoles)
  }

  get roleSettings () {
    return this.data.roleSettings
  }

  sumRole (roleIds: RoleId[]) {
    return roleIds
    .filter((x, i, self) => self.indexOf(x) === i)
    .map((roleId) => {
      return {
        name: MASTER_ROLE[roleId].name,
        code: MASTER_ROLE[roleId].code,
        side: MASTER_ROLE[roleId].side,
        mafia: MASTER_ROLE[roleId].mafia,
        weapon: MASTER_ROLE[roleId].weapon,
        count: roleIds.filter(id => id === roleId).length
      }
    })
    .sort((a, b) => a.code - b.code)
  }

  selectRoleId (roleId: RoleId) {
    this.selectedRoleId = roleId
    this.show = true
  }

  isSniper (roleId: RoleId) {
    return roleId === RoleId.sniper
  }

  isSurvivor (roleId: RoleId) {
    return roleId === RoleId.survivor
  }

  isPickpocket (roleId: RoleId) {
    return roleId === RoleId.pickpocket
  }
}
